import { render, staticRenderFns } from "./ProfileInfoForm.vue?vue&type=template&id=86db70b6&"
import script from "./ProfileInfoForm.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInfoForm.vue?vue&type=style&index=0&id=86db70b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports